import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
Vue.use(Vuetify);
const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        // primary: 'transparent',
        secondary: '#b0bec5',
        anchor: '#8c9eff',
      },
    },
  },
});
const opts = {};

export default new Vuetify(opts);
